import { StatusBadge, StatusBadgeProps } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"
import { TraceabilityStatus } from "@tfg/types/endpoints/traceability"

type TraceabilityStatusCellProps = {
  traceabilityStatus: LibraryResponses.TraceabilityStatus
}

export const TraceabilityStatusCell = ({
  traceabilityStatus,
}: TraceabilityStatusCellProps) => {
  const { t } = useTranslation(["products"])

  const labelMapping: Record<
    LibraryResponses.TraceabilityStatus,
    StatusBadgeProps
  > = {
    [TraceabilityStatus.PENDING]: {
      text: t("lists.cells.traceability.traceabilityStatus.pending"),
      variant: "info",
      icon: null,
    },
    [TraceabilityStatus.ACTIVE]: {
      text: t("lists.cells.traceability.traceabilityStatus.active"),
      variant: "success",
      icon: null,
    },
    [TraceabilityStatus.ERROR]: {
      text: t("lists.cells.traceability.traceabilityStatus.error"),
      variant: "error",
      icon: null,
    },
  }

  return <StatusBadge {...labelMapping[traceabilityStatus]} />
}
